import { isFilestoreDocumentPath } from "./filestore-path";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export type DocumentSource =
  | { kind: "filestore"; path: string }
  | { kind: "s3"; fileId: string }
  | { kind: "presigned-url"; url: string }
  | { kind: "local"; blobUrl: string };

export type ResolveDocumentSourceParams = {
  documentUrl?: string | null;
  fileId?: string | null;
  blobUrl?: string | null;
};

export function isS3FileId(value: string): boolean {
  return UUID_RE.test(value);
}

/** Определяет источник файла для единой функции openDocument. */
export function resolveDocumentSource({
  documentUrl,
  fileId,
  blobUrl,
}: ResolveDocumentSourceParams): DocumentSource | null {
  if (blobUrl) {
    return { kind: "local", blobUrl };
  }

  if (documentUrl) {
    if (isFilestoreDocumentPath(documentUrl)) {
      return { kind: "filestore", path: documentUrl };
    }

    return { kind: "presigned-url", url: documentUrl };
  }

  if (fileId && isS3FileId(fileId)) {
    return { kind: "s3", fileId };
  }

  return null;
}
